
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const HouseRemovals = lazy(() => import('../pages/house-removals/page'));
const OfficeRemovals = lazy(() => import('../pages/office-removals/page'));
const SingleItem = lazy(() => import('../pages/single-item/page'));
const Collections = lazy(() => import('../pages/collections/page'));
const Areas = lazy(() => import('../pages/areas/page'));
const Reviews = lazy(() => import('../pages/reviews/page'));
const About = lazy(() => import('../pages/about/page'));
const FAQs = lazy(() => import('../pages/faqs/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const ThankYou = lazy(() => import('../pages/thank-you/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/house-removals',
    element: <HouseRemovals />,
  },
  {
    path: '/office-removals',
    element: <OfficeRemovals />,
  },
  {
    path: '/single-item-moves',
    element: <SingleItem />,
  },
  {
    path: '/collections-deliveries',
    element: <Collections />,
  },
  {
    path: '/areas-we-cover',
    element: <Areas />,
  },
  {
    path: '/reviews',
    element: <Reviews />,
  },
  {
    path: '/about',
    element: <About />,
  },
  {
    path: '/faqs',
    element: <FAQs />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/thank-you',
    element: <ThankYou />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
